import { render, staticRenderFns } from "./CheckExpiration.vue?vue&type=template&id=5a419348&scoped=true&"
import script from "./CheckExpiration.vue?vue&type=script&lang=js&"
export * from "./CheckExpiration.vue?vue&type=script&lang=js&"
import style0 from "./CheckExpiration.vue?vue&type=style&index=0&id=5a419348&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a419348",
  null
  
)

export default component.exports